
const ENDPOINTS = {

  auth: {
    login: "auth/login",
    me: "users/me",
    register: "auth/register",
    otpVerifyRegistration: "auth/otp/verify-registration",
    refresh: "auth/refresh",
  },

  otp: {
    send: "otp/send",
    resend: "otp/resend",
  },

  passwordReset: {
    sendOtp: "users/otp/resetPassword",
    reset: "users/resetPassword",
  },

  country: {
    all: "country",
  },

  users: {
    all: "/users/all",
    create: "/users",
    update: (id: number | string) => `/users/${id}`,
    delete: (id: number | string) => `/users/${id}`,
    byId: (id: number | string) => `/users/${id}`,

    byEmailId: (emailId: string) => `/users/getUserByEmailId/${emailId}`,
    byName: (name: string) => `/users/getUserByName/${name}`,
    byEmailAddressNative: (emailId: string) => `/users/getUserByEmailAddressNative/${emailId}`,
    byVendorName: (name: string) => `/users/findByVendorName/${name}`,
    byFirstName: (name: string) => `/users/findByFirstName/${name}`,
  },

  notifications: {
    all: "/notification",
    create: "/notification",
    byUserAndType: (userId: number | string, type: string) =>
      `/notification/userId/${userId}/type/${type}`,

    byType: (type: string) => `/notification/type/${type}`,
  },

  shops: {
    all: "/shop",
    filter: "/shop/filtering",
    create: "/shop",
    update: (id: number | string) => `/shop/${id}`,
    delete: (id: number | string) => `/shop/${id}`,
    byId: (id: number | string) => `/shop/${id}`,
    byCustomerId: (customerId: number | string) => `/shop/customerId/${customerId}`,
  },

  categories: {
    all: "/category",
    parentOnly: "/category/parentcat",
    create: "/category",
    update: (id: number | string) => `/category/${id}`,
    delete: (id: number | string) => `/category/${id}`,
    byId: (id: number | string) => `/category/${id}`,
  },

  categoryVariants: {
    byCategoryId: (categoryId: number | string) =>
      `/categoryVariant/categoryId/${categoryId}`,
    create: "/categoryVariant",
    update: (variantId: number | string) => `/categoryVariant/${variantId}`,
    delete: (variantId: number | string) => `/categoryVariant/${variantId}`,
  },

  categoryVariantOptions: {
    create: "/categoryVariantOption",
    update: (optionId: number | string) => `/categoryVariantOption/${optionId}`,
    delete: (optionId: number | string) => `/categoryVariantOption/${optionId}`,
  },

  collections: {
    all: "/collection",
    create: "/collection",
    update: (id: number | string) => `/collection/${id}`,
    delete: (id: number | string) => `/collection/${id}`,
    byId: (id: number | string) => `/collection/${id}`,
  },

  bulkUpload: {
    categories: "/products/categories",
    template: "/products/template/download",
    upload: "/products/bulk-upload",
    review: "/products/bulk-upload/review",
    confirm: "/products/bulk-upload/review/confirm",
    final: "/products/bulk-upload/final",
    finalize: "/products/bulk-upload/finalize",
  },

  products: {
    all: "/products",
    create: "/products",
    update: (id: number | string) => `/products/${id}`,
    byId: (id: number | string) => `/products/${id}`,
    delete: (id: number | string) => `/products/${id}`,
    filter: "/products/filter",
    withCategoryVariant: (categoryId: number | string, productId: number | string) =>
      `/products/v1/categoryVariant/categoryId/${categoryId}/productId/${productId}`,
    updateThumbnail: (productId: number | string) => `/products/${productId}/updateThumbnail`,
  },

  productSku: {
    all: "/productSku",
    create: "/productSku",
    update: (skuId: number | string) => `/productSku/${skuId}`,
    delete: (skuId: number | string) => `/productSku/${skuId}`,
    updateThumbnail: (productId: number | string) =>
      `/products/${productId}/updateThumbnail`,
    updatePrice: (productId: number | string) => `/products/${productId}/updatePrice`,
  },

  media: {
    all: "/media/all",
    createBulk: "/medias",
    byId: (id: number | string) => `/media/${id}`,
    create: "/media",
    upload: "/media/mediaUpload",
    uploadMultiple: "/media/mediaUploads",
    uploadMultipleFiles: "/upload/uploadMultipleFiles",
    productFiles: (productId: number | string) =>
      `/upload/productsfiles/${productId}`,
    sliderFiles: (productId: number | string) => `/upload/sliderfiles/${productId}`,

    byProduct: (productId: number | string) => `/media/product/${productId}`,
    deleteMedia: (type: string, mediaId: number | string) =>
      `/upload/deleteMedia/${type}/${mediaId}`,
    updateSeq: (mediaId: number | string, seq: number | string) =>
      `/media/updateSeq/${mediaId}/${seq}`,
    updateSeqByProductId: (prodId: number | string) =>
      `/media/updateSeqByProductId/${prodId}`,
  },

  orders: {
    all: "orders",
    filter: "orders/filtering",
    byUser: (userId: number | string) => `orders/getuserorder/${userId}`,
    byId: (orderId: number | string) => `orders/${orderId}`,
    create: "orders",

    orderStatus: "orders/orderStatus",

  },

  addresses: {
    byUser: (userId: number | string) => `address/getAddressByUserId/${userId}`,
    create: "address",
    update: (addressId: number | string) => `address/${addressId}`,
    delete: (addressId: number | string) => `address/${addressId}`,
    updateDefault: "address/updatedefaultaddress",
  },

  orderDetails: {

    orderDetailStatus: "orderdetails/orderDetailStatus",
  },

  refunds: {
    create: "refunds",
    all: "refunds",

    filter: "refunds/filtering",
    byId: (refundId: number | string) => `refunds/${refundId}`,
    updateStatus: (refundId: number | string) => `refunds/${refundId}/status`,

    process: "refunds/process",
  },

  payments: {

    filter: "payment/filtering",
    byOrder: (orderId: number | string) => `payment/order/${orderId}`,
  },

  reviews: {

    all: "ratings",
    byId: (ratingId: number | string) => `ratings/${ratingId}`,
    byUser: (userId: number | string) => `ratings/${userId}/userReviews`,
  },
};

export default ENDPOINTS;
